/* =============================================================================
   Ella Custom JS — ajustes propios de la tienda.
   Se carga solo si el ajuste `use_custom_js` del tema esta activado.
   ============================================================================= */

/* -----------------------------------------------------------------------------
   Koala Upsell & Gift: reabrir el drawer despues de su recarga.

   Al anadir un producto, la app mete el regalo con
   POST /cart/add.js?_koala_gifts_internal=true y despues RECARGA la pagina
   (verificado: performance.getEntriesByType('navigation')[0].type === 'reload').
   La recarga borra la clase `cart-sidebar-show` del <body>, asi que el drawer
   que el tema acababa de abrir se cierra y el cliente no llega a ver el regalo.

   Aqui no se puede evitar la recarga — la provoca la app. Lo que se hace es
   dejar una marca antes de que ocurra y, al volver a cargar, reabrir el drawer.

   El drawer se abre simulando un clic en [data-cart-sidebar] en lugar de tocar
   el DOM a mano, porque `halo` es una variable privada de theme.js y no esta
   expuesta en window: no hay forma de llamar a halo.updateSidebarCart() desde
   fuera. El clic dispara el camino propio del tema
   (Shopify.getCart -> halo.updateSidebarCart + addClass('cart-sidebar-show')),
   asi que el drawer se repinta con el regalo ya dentro.
   ----------------------------------------------------------------------------- */
(function () {
  'use strict';

  var MARCA = 'levni:reabrir-drawer';
  var VIGENCIA_MS = 30000;   // pasado este tiempo la marca se considera vieja
  var ESPERA_MAX_MS = 5000;  // el handler del tema se ata dentro de halo.init()
  var REINTENTO_MS = 150;

  function esAltaDeRegalo(url, metodo) {
    if (!url) return false;
    url = String(url);
    return /[?&]_koala_gifts_internal=true/.test(url) &&
           /\/cart\/add(\.js)?/.test(url) &&
           String(metodo || 'GET').toUpperCase() === 'POST';
  }

  function marcar() {
    try {
      sessionStorage.setItem(MARCA, String(Date.now()));
    } catch (e) {
      /* modo privado o cookies bloqueadas: sin marca no se reabre, nada mas */
    }
  }

  /* --- 1. Detectar el alta del regalo, antes de que llegue la recarga --- */

  if (window.fetch) {
    var fetchOriginal = window.fetch;
    window.fetch = function (entrada, opciones) {
      try {
        var url = typeof entrada === 'string' ? entrada : (entrada && entrada.url);
        var metodo = (opciones && opciones.method) || (entrada && entrada.method) || 'GET';
        if (esAltaDeRegalo(url, metodo)) marcar();
      } catch (e) {}
      return fetchOriginal.apply(this, arguments);
    };
  }

  var abrirOriginal = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (metodo, url) {
    try {
      if (esAltaDeRegalo(url, metodo)) marcar();
    } catch (e) {}
    return abrirOriginal.apply(this, arguments);
  };

  /* --- 2. Tras la recarga, reabrir el drawer --- */

  function hayMarcaVigente() {
    try {
      var t = sessionStorage.getItem(MARCA);
      if (!t) return false;
      sessionStorage.removeItem(MARCA);          // de un solo uso
      return (Date.now() - Number(t)) < VIGENCIA_MS;
    } catch (e) {
      return false;
    }
  }

  function drawerAbierto() {
    return document.body.classList.contains('cart-sidebar-show');
  }

  /* El tema ata el clic con jQuery dentro de halo.init(). Si se pulsa antes de
     que exista ese handler, el <a href="/cart"> navegaria a la pagina de carrito. */
  function handlerListo(el) {
    try {
      var eventos = window.jQuery && window.jQuery._data && window.jQuery._data(el, 'events');
      return !!(eventos && eventos.click && eventos.click.length);
    } catch (e) {
      return false;
    }
  }

  function abrirDrawer(el) {
    /* Red de seguridad: aunque el handler del tema faltara, este listener impide
       que el clic navegue. No corta la propagacion, asi que el tema sigue actuando. */
    var sinNavegar = function (ev) { ev.preventDefault(); };
    el.addEventListener('click', sinNavegar, true);
    try {
      el.click();
    } finally {
      el.removeEventListener('click', sinNavegar, true);
    }
  }

  function reabrir() {
    if (!hayMarcaVigente()) return;
    if (document.body.classList.contains('template-cart')) return;  // ahi el icono hace scroll

    var limite = Date.now() + ESPERA_MAX_MS;

    (function intentar() {
      if (drawerAbierto()) return;

      var disparador = document.querySelector('[data-cart-sidebar]');
      if (disparador && handlerListo(disparador)) {
        abrirDrawer(disparador);
        /* Se comprueba en el siguiente ciclo: si no abrio, se reintenta. */
      }

      if (Date.now() < limite) setTimeout(intentar, REINTENTO_MS);
    })();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', reabrir);
  } else {
    reabrir();
  }

  /* ---------------------------------------------------------------------------
     Drawer del carrito: darle sitio a los productos.

     Medido con 2 lineas en el carrito, ventana de 897px:
       lista de productos ......  197px
       barra de herramientas ...   80px
       totales .................  137px
       botones + metodos pago ..  290px
     y ademas 161px de contenido recortado, porque .previewCart-wrapper lleva
     overflow:hidden. Resultado: solo cabe un producto.

     Los "Metodos de Pago" del pie (titulo 34px + fila de iconos 104px = 138px)
     ya aparecen en la ficha de producto y en el checkout, asi que dentro del
     drawer solo quitan espacio. Ocultandolos ahi, la lista casi se duplica.

     Va inyectado desde aqui en vez de en custom.css a proposito: asi todo el
     arreglo viaja en un unico archivo y basta con activar un ajuste. El drawer
     no es visible al cargar, asi que no hay parpadeo.
     --------------------------------------------------------------------------- */
  (function estilosDelDrawer() {
    var css = [
      '#halo-cart-sidebar .payment-methods-title,',
      '#halo-cart-sidebar .payment-methods-row { display: none !important; }',
      '#halo-cart-sidebar .previewCart {',
      '  flex: 1 1 auto;',
      '  min-height: 0;',          /* sin esto el flex no cede y la lista se queda corta */
      '  overflow-y: auto;',
      '}',
      '#halo-cart-sidebar .previewCartInfo { flex: 0 0 auto; }',

      /* Pie mas compacto. Medido: el bloque de totales + botones ocupaba 339px,
         y 90 de ellos eran padding-bottom muerto (dejaba 84px vacios al fondo). */
      /* env() anade solo lo que el propio dispositivo reserve (indicador de inicio
         del iPhone). En escritorio vale 0, asi que no sobra espacio en ninguno. */
      '#halo-cart-sidebar .previewCartInfo {',
      '  padding-bottom: 20px;',
      '  padding-bottom: calc(20px + env(safe-area-inset-bottom, 0px));',
      '}',
      '#halo-cart-sidebar .previewCartTotals { margin-top: 4px; }',
      '#halo-cart-sidebar .previewCartTotals.shipTotal { margin-top: 8px; }',
      /* La nota lleva font-size:0 en el contenedor y el texto en un hijo. */
      '#halo-cart-sidebar .previewCartTotals.shipTotal > * {',
      '  font-size: 12px;',
      '  line-height: 1.35;',
      '}',
      '#halo-cart-sidebar .previewCartAction { margin-top: 12px; }',

      /* Los dos botones estaban pegados: 0px entre ellos. */
      '#halo-cart-sidebar #cart-sidebar-checkout { margin-bottom: 10px; }',

      /* Orden descendente: lo ultimo anadido arriba. Se hace con column-reverse
         y no reordenando el DOM porque el tema repinta el drawer entero en cada
         cambio del carrito (halo.updateSidebarCart), y cualquier reordenacion
         por JS se perderia en el siguiente repintado. El CSS se reaplica solo.
         Contrapartida: invierte lo que se ve, no el DOM, asi que un lector de
         pantalla y el tabulador siguen recorriendo el orden original. */
      '#halo-cart-sidebar .previewCartList {',
      '  display: flex;',
      '  flex-direction: column-reverse;',
      '}'
    ].join('\n');

    var hoja = document.createElement('style');
    hoja.setAttribute('data-levni', 'drawer');
    hoja.appendChild(document.createTextNode(css));
    (document.head || document.documentElement).appendChild(hoja);
  })();
})();
